// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"0d3e757b","317":"ac9f9d00","917":"223a8756"}[chunkId] + ".chunk.js";
};